import React from "react";
import AboutDriveImage1 from "../../assets/img/clinical.jpg";
import AboutDriveImage2 from "../../assets/img/drive2.jpg";
import "../WhatDrivesUs.css";

export default function Clinical() {
  return (
    <div className="wd-img top-img">
            <img src={AboutDriveImage1} alt="Who" />
          </div>
  );
}

